import React, {Component} from 'react'
import {connect} from 'react-redux'
import {deleteResource, getResource, updateResource} from '../../../data/actions/resource'
import LocalStorage from '../../../util/localStorage'
import Resources from '../../../data/services/resources'
import {download} from '../../../data/actions/download'
import {Field, FieldsManager} from '../../../data/services/fields'
import {
    ArrowRightOnRectangleIcon,
    CheckCircleIcon,
    EyeIcon,
    MagnifyingGlassIcon,
    PencilIcon,
    TrashIcon
} from '@heroicons/react/24/outline'
import {
    ACCOUNT_TYPE_CASH,
    DEFAULT_CRUD_STATE,
    DEFAULT_METADATA_SELECT_SEARCH_QUERY,
    DEFAULT_QUERY_LIMIT,
    DELETE_PERM,
    MAJOR_ACCOUNT_TYPE_ASSET,
    READ_PERM,
    RECONCILED_FILTER,
    UPDATE_PERM
} from '../../../util/util-constants'
import {
    checkPerm,
    classNames,
    getDefaultTableOptions,
    getDefaultTableOptionsJSON,
    getProp,
    mergeDeep,
    renderExpenseStatusBadge,
    saveTableColumns,
    verifyFilterFields
} from '../../../common/util/util-helpers'
import {currentDate, toFrontDateTime} from '../../../common/util/util-dates'
import {genericMoneyFormatter} from '../../../common/util/util-vanilla'
import {getSecondResource,} from '../../../data/actions/secondResource'
import ExpenseExpenseDetailsDialog from '../dialogs/invoice-expense-details-dialog'
import {getDialogResource, updateDialogResource} from '../../../data/actions/dialogResource'
import Tippy from '@tippyjs/react'
import {getThirdResource} from '../../../data/actions/thirdResource'
import {DocumentArrowDownIcon} from '@heroicons/react/20/solid'
import ModalConfirm from "../../../common/components/modal/modal-confirm";
import ModalSaveResource from "../../../common/components/modal/modal-save-resource";
import ModalDefault from "../../../common/components/modal/modal-default";
import ResourceTable from "../../../common/components/resource-table";
import TableOptionsDialog from "../../../common/components/resource-table/table-components/table-options-dialog";
import Pagination from "../../../common/components/resource-table/table-components/pagination";
import NoRecords from "../../../common/components/no-records-found/no-records";
import TableCard from "../../../common/components/resource-table/table-components/table-card";
import TableFilters from "../../../common/components/resource-table/table-components/table-filters";
import TableSettingsPopOver from "../../../common/components/resource-table/table-components/table-settings-popover";
import ActiveFilters from "../../../common/components/resource-table/table-components/active-filters";
import {fillFieldsFromData} from "../../../common/util/util-fields";
import TableCardFooter from "../../../common/components/resource-table/table-components/table-card-footer";
import ResourceTableDialog from "../../../common/components/modal/resource-table-dialog";
import Button from "../../../common/components/button";
import FileViewer from "../../../common/components/file-viewer/components";
import Env from "../../../util/env";
import {getJWT} from "../../../common/util/util-auth";

class TransactionsTab extends Component {
    constructor(props) {
        super(props)

        this.pagePath = this.props.location.pathname.substring(1) + '_expense_transactions'

        this.tablePageDefaults = {
            behaviour: {
                rowSelect: true,
                canAdjustWidth: true,
                hasMenu: true
            },
            style: {
                condensed: true,
                isGPUAccellerated: true
            }
        }

        this.state = {
            // Default state
            ...DEFAULT_CRUD_STATE,
            sortBy: 'Date',
            sort: 'DESC',

            // Fields
            fields: this.getFields(),
            tableOptions: getDefaultTableOptions(this.getFields(), this.tablePageDefaults, this.pagePath, this.props.translate),

            // Filter, and header fields
            queryFilterFields: this.getQueryFilterFields(),

            confirmModalOpen: false,
            isDetailsDialogVisible: false,
            isTransactionsDialogVisible: false,

            isTableFullScreen: false,

            // Dialog(s)
            editModalOpen: false,
            selectedItems: {},
            selectedTransactions: {},
        }

        if (!this.state.tableOptions.behaviour.hasMenu) {
            this.state.tableOptions.behaviour = Object.assign(this.state.tableOptions.behaviour, this.tablePageDefaults.behaviour)
        }

        this.state = mergeDeep(this.state, verifyFilterFields(
            LocalStorage.rehydrateState(this.pagePath),
            this.state.queryFilterFields
        ))

        this.transactionIDsInitial = []
        this.transactionIDsCurrent = []
    }

    /** Lifecycle
     ================================================================= */
    componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.breakpoint !== this.props.breakpoint && this.props.breakpoint.index <= 1 && this.state.queryFilterFields.limit.value !== 10) {
            this.handleFilterInputChange('limit', 10)
        }

        if (!prevProps.dialogResource.data?.list?.length && this.props.dialogResource.data?.list?.length) {
            this.transactionIDsInitial = this.props.dialogResource.data.list.map((transaction) => transaction['SendPaymentID'])
        }

        if (this.props.dialogResource.data?.list?.length &&
            (prevProps.dialogResource.data?.list?.length !== this.props.dialogResource.data.list.length)) {
            this.transactionIDsCurrent = this.props.dialogResource.data?.list.map((transaction) => transaction['SendPaymentID'])
        }

    }

    /** Data Events
     ================================================================= */
    fetchData = () => {
        this.props.dispatch(getResource({
            user: LocalStorage.get('user'),
            resource: this.getResource(),
            query: this.getQuery()
        }))
    }

    fetchDetailsData = () => {
        this.props.dispatch(getDialogResource({
            user: LocalStorage.get('user'),
            query: {
                SendBatchPaymentID: this.state?.selectedTransactionsItem?.SendBatchPaymentID,
                SendPaymentID: this.state?.selectedTransactionsItem?.SendPaymentID
            },
            resource: Resources.ExpenseTransactionsDetails
        }))
    }

    fetchExpenseDialogData = () => {
        this.props.dispatch(getSecondResource({
            user: LocalStorage.get('user'),
            query: {
                ExpenseID: this.state.selectedItem.ExpenseID
            },
            resource: Resources.ExpenseExpense
        }))
    }

    onAttachTransactions = () => {
        this.props.dispatch(updateDialogResource({
            user: LocalStorage.get('user'),
            params: {
                SendBatchPaymentID: this.state?.selectedTransactionsItem?.SendBatchPaymentID,
                SendPaymentIDs: Object.keys(this.state.selectedTransactions)
            },
            resource: Resources.ExpenseTransactionsAttach,
            piggyResource: Resources.ExpenseTransactionsDetails,
            query: {
                SendBatchPaymentID: this.state?.selectedTransactionsItem?.SendBatchPaymentID,
                SendPaymentID: this.state?.selectedTransactionsItem?.SendPaymentID
            }
        }))
        this.handleToggleAddTransactionsModal()
    }

    downloadExcel = () => {
        this.props.dispatch(download({
            user: LocalStorage.get('user'),
            resource: Resources.ExpenseTransactions,
            query: Object.assign(
                {format: 'EXCEL', name: 'expenses_expenses' + currentDate() + '.xlsx'},
                this.getQuery()
            )
        }))
    }

    /** UI Events
     ================================================================= */
    handleInputChange = (name, value) => {
        this.setState({fields: FieldsManager.updateField(this.state.fields, name, value)}, this.fetchData)
    }

    handleUpdateSort = (sortBy) => {
        this.setState({
            sortBy: sortBy,
            sort: (this.state.sortBy === sortBy) ? (this.state.sort === 'ASC' ? 'DESC' : 'ASC') : 'ASC'
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleUpdateOffset = (offset, num) => {
        this.setState({
            offset: offset,
            paginationPage: num
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleFullScreenToggle = () => {
        this.setState({
            isTableFullScreen: !this.state.isTableFullScreen
        })
    }

    handleFilterInputChange = (name, value) => {
        this.setState({
            queryFilterFields: FieldsManager.updateField(this.state.queryFilterFields, name, value),
            offset: 0,
            paginationPage: 1
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleClearFiltersClick = () => {
        this.setState({
            queryFilterFields: this.getQueryFilterFields()
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleToggleEditModel = (item = null) => {
        this.setState({
            selectedItem: item,
            editModalOpen: !this.state.editModalOpen
        })
    }

    handleSetTableColumnOptions = (columns) => {
        let tableOptions = Object.assign({}, this.state.tableOptions)

        tableOptions.columns = columns.reduce((memo, it) => {
            memo[it.name] = it
            return memo
        }, {})

        this.setState({
            tableOptions,
            columnsModalOpen: false
        }, () => saveTableColumns(this.pagePath, tableOptions))
    }

    getDefaultTableColumnOptions = () => {
        return getDefaultTableOptionsJSON(this.getFields(), this.tablePageDefaults, this.props.translate)
    }

    handleToggleColumnSettingsDialog = () => {
        this.setState({
            columnsModalOpen: !this.state.columnsModalOpen
        })
    }
    handleToggleEditModal = (item = null) => {
        this.setState({
            selectedItem: item,
            editModalOpen: !this.state.editModalOpen
        })
    }

    toggleShowDetails = (item = null) => {
        this.setState({
            selectedItem: item,
            isDetailsDialogVisible: !this.state.isDetailsDialogVisible,
        })
    }

    handleToggleShowTransactions = (item = null) => {
        this.setState({
            selectedTransactionsItem: item,
            isTransactionsDialogVisible: !this.state.isTransactionsDialogVisible,
        }, () => {
            this.state.isTransactionsDialogVisible && this.fetchDetailsData()

            if (!this.state.isTransactionsDialogVisible && !this.areTransactionsEqual(this.transactionIDsInitial, this.transactionIDsCurrent)) {
                this.fetchData()
            }

        })
    }

    handleToggleAddTransactionsModal = () => {
        this.setState({
            addTransactionsModalOpen: !this.state.addTransactionsModalOpen,
            selectedTransactions: {}
        })
    }

    handleSelectTransaction = (item) => {
        let listClone = Object.assign({}, this.state.selectedTransactions)

        const existingItem = !!listClone[item.SendPaymentID]

        if (!!existingItem) {
            delete listClone[item.SendPaymentID]
        } else {
            listClone[item.SendPaymentID] = item
        }

        this.setState({
            selectedTransactions: listClone
        })
    }

    handleSelectAllTransactions = (selectAll) => {
        const data = getProp(this.props.thirdResource.data, 'list', []);

        let selectedTransactions = Object.assign({}, this.state.selectedTransactions)

        if (!selectAll) {
            Object.assign(selectedTransactions, data.reduce((memo, it) => {
                memo[it.SendPaymentID] = it.SendPaymentID
                return memo
            }, {}))
        } else {
            let selectedRowsKeys = Object.keys(selectedTransactions)
            data.forEach(it => {
                if (selectedRowsKeys.includes(it.SendPaymentID.toString())) {
                    delete selectedTransactions[it.SendPaymentID]
                }
            })
        }

        this.setState({selectedTransactions})
    }

    handleToggleConfirmTransactionModal = (item = null) => {
        this.setState({
            selectedTransactionItem: item,
            confirmTransactionModalOpen: !this.state.confirmTransactionModalOpen
        })
    }

    handleToggleConfirmModal = (item = null) => {
        this.setState({
            selectedItem: item,
            confirmModalOpen: !this.state.confirmModalOpen
        })
    }

    handleToggleRemitModal = (item = null) => {
        this.setState({
            selectedTransactionsItem: item,
            remitModalOpen: !this.state.remitModalOpen
        })
    }

    setOptions = (options) => {
        this.setState({
            tableOptions: options
        }, () => saveTableColumns(this.pagePath, options))
    }

    /** Helpers
     ================================================================= */
    saveFilters = () => {
        LocalStorage.persistState(this.pagePath, this.state, ['sortBy', 'sort', 'limit', 'offset', 'paginationPage', 'input'])
    }

    sortByRefNumber = (unsortedTransactions) => {
        if (!Array.isArray(unsortedTransactions)) {
            return [];
        }

        const compareFunction = (a, b) => a.RefNumber?.localeCompare(b.RefNumber, 'en', {numeric: true})
        return unsortedTransactions.sort(compareFunction)
    }

    getQuery = () => {
        return {
            sort: this.state.sort,
            sortBy: this.state.sortBy,
            offset: this.state.offset,

            ...FieldsManager.getFieldKeyValues(this.state.queryFilterFields)
        }
    }

    getResource = () => {
        return Resources.ExpenseTransactions
    }

    getFields = () => {
        return {
            Expenses: new Field('Expenses', '', [], false, 'custom', {
                render: (item) => {
                    if (item.Items) {
                        const isBatch = (item.Count >= 1 && item.SendBatchPaymentID != null)
                        return (
                            <div className={'flex'}>
                                {isBatch && <div
                                    className={'bg-green-600 text-white inline-flex text-center px-1 rounded-btn text-sm font-medium whitespace-nowrap'}>{item.Count}</div>}
                                <div className="ml-1 max-w-[24rem] truncate">{item.Items}</div>
                            </div>
                        )
                    }
                    return ''
                },
                omitSort: true
            }),
            PayTo: new Field('PayTo', '', [], false, 'custom', {
                render: (item) => {
                    if (item.PayTo) {
                        return <div className="max-w-[24rem] truncate">{item.PayTo}</div>
                    }
                    return ''
                },
                omitSort: true
            }),
            Deposit: new Field('Deposit', '', [], false, 'money', {
                omitSort: true,
                label: 'TransactionAmount',
                render: (item) => {
                    return (
                        <div>
                            {item.ReconciliationDate ? (
                                    <Tippy content={'Reconciled: ' + toFrontDateTime(item.ReconciliationDate)}>
                                        <div className="flex justify-end">
                                            <CheckCircleIcon className="mr-4 w-5 h-5 text-green-600"/>
                                            <div>
                                                {genericMoneyFormatter(item.Deposit)}
                                            </div>
                                        </div>
                                    </Tippy>
                                ) :
                                <div className={'text-right'}>
                                    {genericMoneyFormatter(item.Deposit)}
                                </div>}
                        </div>
                    )
                },
            }),
            Date: new Field('Date', '', [], false, 'date', {}),
            Account: new Field('Account', '', [], false, 'text', {
                omitSort: true
            }),
            PaymentTypeID: new Field('PaymentTypeID', '', [], false, 'select', {
                omitSort: true
            }),
            Description: new Field('Description', '', [], false, 'text', {
                render: (it) => (<div>{it.SendPaymentDescription ?? it.SendBatchPaymentDescription}</div>),
                omitSort: true,
                label: 'Description'
            }),
        }
    }

    getDetailsFields = () => {
        return {
            AutoCounter: new Field('AutoCounter', '', [], false, 'text', {
                omitSort: true
            }),
            RefNumber: new Field('RefNumber', '', [], false, 'text', {
                omitSort: true
            }),
            ChargeTo: new Field('ChargeTo', '', [''], false, 'custom', {
                omitSort: true,
                label: 'PayTo',
                render: (it) => it.Organization ?? it.Contact
            }),
            Amount: new Field('Amount', '', [], false, 'money', {
                omitSort: true,
                label: 'PaymentAmount',
            }),
            ExpenseAmount: new Field('ExpenseAmount', '', [], false, 'money', {
                omitSort: true
            }),
            ExpenseStatus: new Field('ExpenseStatus', '', [''], false, 'custom', {
                omitSort: true,
                render: (it) => renderExpenseStatusBadge(it)
            }),
        }
    }

    getQueryFilterFields = () => {
        return {
            query: new Field('query', '', [''], false, 'search', {
                containerClass: 'col-md-3'
            }, {}),
            StartDate: new Field('StartDate', '', [''], false, 'date', {addContainerClass: 'z-30'}, {isClearable: true}),
            EndDate: new Field('EndDate', '', [''], false, 'date', {}, {isClearable: true}),
            AccountID: new Field('AccountID', '', [], false, 'select-search', {}, {isClearable: true}),
            PaymentTypeID: new Field('PaymentTypeID', '', [], false, 'select', {}, {isClearable: true}),
            ReconciliationDate: new Field('ReconciliationDate', '', [], false, 'select', {
                label: 'IsReconciled'
            }, {
                values: RECONCILED_FILTER,
                isClearable: true
            }),
            limit: new Field('limit', DEFAULT_QUERY_LIMIT, [''], false, 'select', {
                hasPortal: true,
                addContainerClass: 'z-30',
                containerClass: 'col-md-6 limit-field-container float-right relative z-30', hideLabel: true
            }, {menuPlacement: 'top'})
        }
    }

    getEditFields = (item = null) => {
        const fieldTemplates = {
            Date: new Field('Date', '', [''], false, 'date', {addContainerClass: 'col-span-full'}),
            Description: new Field('Description', item?.SendPaymentDescription ?? item?.SendBatchPaymentDescription, [], false, 'text', {
                addContainerClass: 'col-span-full',
            }),
        }

        return fillFieldsFromData(fieldTemplates, item)
    }

    areTransactionsEqual = (initialTransactions, currentTransactions) => {
        if (initialTransactions.length !== currentTransactions.length) {
            return false;
        }

        let sortedInitial = initialTransactions.slice().sort();
        let sortedCurrent = currentTransactions.slice().sort();

        for (let i = 0; i < initialTransactions.length; i++) {
            if (sortedInitial[i] !== sortedCurrent[i]) {
                return false;
            }
        }
        return true;
    }

    /** Render
     ================================================================= */
    render() {
        const {translate, resource} = this.props

        const data = getProp(resource.data, 'list', [])
        const count = getProp(resource.data, 'count', 0)

        const transactionsData = getProp(this.props, 'dialogResource.data.list', [])
        const transactionsDataIsLoading = getProp(this.props, 'dialogResource.isLoading', false)

        return (
            <React.Fragment>
                <div className="flex mb-2">
                    <ActiveFilters
                        filterFields={this.state.queryFilterFields}
                        onLabelClick={this.handleFilterInputChange}
                        onClearFiltersClick={this.handleClearFiltersClick}
                        translate={translate}
                    />

                    <div className="flex ml-auto">

                        <Tippy content={translate('text.download_excel')}>
                            <button
                                className="btn-icon"
                                onClick={this.downloadExcel}
                            >
                                <DocumentArrowDownIcon className="w-5 h-5"/>
                            </button>
                        </Tippy>

                        <TableSettingsPopOver
                            options={this.state.tableOptions}
                            setOptions={this.setOptions}
                            toggleColumnSettingsDialog={this.handleToggleColumnSettingsDialog}
                            translate={translate}
                        />
                    </div>
                </div>

                <TableCard
                    addClass={
                        classNames(
                            this.state.isTableFullScreen
                                ? 'fixed inset-1 -top-1 z-50'
                                : undefined
                        )}
                >

                    <TableFilters
                        hideLimit
                        filterFields={this.state.queryFilterFields}
                        handleInputChange={this.handleFilterInputChange}
                        translate={translate}
                        forceDialog={true}
                        onRefreshTable={this.fetchData}
                        selects={{
                            AccountID: {
                                api: 'api/' + Resources.AccountsQuick,
                                query: {
                                    ...DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
                                    MainAccountTypeID: MAJOR_ACCOUNT_TYPE_ASSET,
                                    AccountTypeID: ACCOUNT_TYPE_CASH
                                },
                                searchMap: (item) => ({
                                    value: item.AccountID,
                                    label: item.AccountNumber + ' ' + item.AccountName,
                                    metadata: item
                                })
                            }
                        }}
                        onFullScreenToggle={this.handleFullScreenToggle}
                        isTableFullScreen={this.state.isTableFullScreen}
                        isLoading={resource.isLoading}
                    />

                    <ResourceTable
                        tableKey={'SendPaymentID'}
                        data={data}
                        fields={this.getFields()}

                        translate={translate}
                        isLoading={resource.isLoading}

                        options={this.state.tableOptions}

                        limit={this.state.queryFilterFields.limit.value}
                        sort={this.state.sort}
                        sortBy={this.state.sortBy}
                        onSortChange={this.handleUpdateSort}

                        saveTableOptions={this.setOptions}

                        onRowClick={checkPerm(this.getResource(), READ_PERM) && this.handleToggleShowTransactions}

                        actions={[
                            {
                                action: this.handleToggleShowTransactions,
                                icon: EyeIcon,
                                visible: (it) => (it.SendPaymentID || it.SendBatchPaymentID),
                                hasPerm: checkPerm(this.getResource(), READ_PERM),
                                title: translate('text.show_details'),
                            },
                            {
                                action: this.handleToggleRemitModal,
                                icon: MagnifyingGlassIcon,
                                title: translate('text.preview_document'),
                            },
                            {
                                action: this.handleToggleEditModal,
                                icon: PencilIcon,
                                visible: (it) => (it.SendPaymentID || it.SendBatchPaymentID) && !it.ReconciliationDate,
                                hasPerm: checkPerm(this.getResource(), UPDATE_PERM),
                                title: translate('text.edit'),
                            },
                            {
                                action: this.handleToggleConfirmModal,
                                icon: TrashIcon,
                                visible: (it) => (it.SendPaymentID || it.SendBatchPaymentID) && !it.ReconciliationDate,
                                hasPerm: checkPerm(Resources.ExpensePayment, DELETE_PERM),
                                title: translate('text.delete_item'),
                            }
                        ]}
                    />

                    <NoRecords
                        show={(data.length === 0) && !resource.isLoading}
                        title={translate('text.no_records')}
                        addClass={'pt-16 pb-10'}
                    />

                    <TableCardFooter
                        show={!(!data.length && !resource.isLoading)}
                    >
                        <Pagination
                            count={count}
                            isLoading={resource.isLoading}
                            // hideRowsPerPage={this.state.breakpoint.index <= 1}
                            handleQueryChange={
                                (name, value, currentPage) => name === 'offset'
                                    ? this.handleUpdateOffset(value, currentPage)
                                    : this.handleFilterInputChange(name, value)
                            }
                            pageOffset={this.state.offset}
                            queryFields={this.state.queryFilterFields}
                            translate={translate}
                        />
                    </TableCardFooter>
                </TableCard>

                <TableOptionsDialog
                    show={this.state.columnsModalOpen}
                    pagePath={this.pagePath}
                    columns={this.state.tableOptions.columns}
                    setTableColumnOptions={this.handleSetTableColumnOptions}
                    getDefaultTableColumnOptions={this.getDefaultTableColumnOptions}
                    onClose={this.handleToggleColumnSettingsDialog}
                    translate={translate}
                />

                <ModalDefault
                    show={this.state.isTransactionsDialogVisible}
                    widthClass={'max-w-6xl'}
                    title={translate('text.Payments')}

                    closeButtonLabel={translate('btn.Close')}
                    onClose={() => this.handleToggleShowTransactions()}
                >
                    <div className="p-5">
                        {this.state.selectedTransactionsItem?.SendBatchPaymentID && !this.state.selectedTransactionsItem?.ReconciliationDate && (
                            <div className="flex justify-end mb-3">
                                <Button
                                    appearance={'primary'}
                                    onClick={this.handleToggleAddTransactionsModal}
                                    hasPerm={checkPerm(Resources.ExpenseTransactionsAttach, UPDATE_PERM)}
                                >
                                    {translate('btn.AddPaymentToTransaction')}
                                </Button>
                            </div>
                        )}

                        <ResourceTable
                            tableKey={'SendPaymentID'}
                            maxHeightClass={'max-h-[calc(100vh-32rem)]'}
                            data={this.sortByRefNumber(transactionsData)}
                            fields={this.getDetailsFields()}

                            translate={translate}
                            isLoading={transactionsDataIsLoading}

                            limit={(transactionsData?.length ?? 10)}

                            onRowClick={this.toggleShowDetails}
                            actions={[
                                {
                                    action: this.toggleShowDetails,
                                    icon: EyeIcon,
                                    hasPerm: checkPerm(Resources.ExpenseExpense, READ_PERM),
                                    title: translate('text.show_details'),
                                },
                                {
                                    action: this.handleToggleConfirmTransactionModal,
                                    icon: ArrowRightOnRectangleIcon,
                                    visible: () => transactionsData?.length !== 1 && !this.state.selectedTransactionsItem?.ReconciliationDate,
                                    hasPerm: checkPerm(Resources.ExpenseTransactionsDetach, UPDATE_PERM),
                                    title: translate('text.detach'),
                                },
                            ]}
                        />
                    </div>

                    <ResourceTableDialog
                        title={"btn.AddPaymentToTransaction"}
                        dispatch={this.props.dispatch}
                        show={this.state.addTransactionsModalOpen}
                        resource={Resources.ExpenseTransactions}
                        alternateDialogResource={this.props.thirdResource}
                        alternateDialogResourceCall={getThirdResource}
                        fields={this.getFields()}
                        fieldsFilter={{
                            StartDate: new Field('StartDate', '', [''], false, 'date', {addContainerClass: 'col-span-3'}, {isClearable: true}),
                            EndDate: new Field('EndDate', '', [''], false, 'date', {addContainerClass: 'col-span-3'}, {isClearable: true}),
                        }}
                        defaultQuery={{
                            SendBatchPaymentID: this.state?.selectedTransactionsItem?.SendBatchPaymentID,
                            SendPaymentID: this.state?.selectedTransactionsItem?.SendPaymentID,
                            singleOnly: 1,
                            AccountID: this.state?.selectedTransactionsItem?.AccountID
                        }}
                        primaryKey={'SendPaymentID'}
                        tableKey={'SendPaymentID'}
                        selectedRows={this.state.selectedTransactions}
                        onSelectRow={this.handleSelectTransaction}
                        onRowClick={this.handleSelectTransaction}
                        onSelectAllClick={this.handleSelectAllTransactions}
                        translate={translate}
                        buttonLabel={translate('btn.save')}
                        onButtonClick={this.onAttachTransactions}
                        buttonDisabled={!Object.keys(this.state.selectedTransactions).length}
                        closeButtonLabel={translate('btn.Cancel')}
                        onClose={this.handleToggleAddTransactionsModal}
                        hasRefreshButton
                    />

                </ModalDefault>

                <ModalDefault
                    show={this.state.isDetailsDialogVisible}
                    widthClass={'max-w-full'}
                    title={translate('text.ExpenseID')}

                    closeButtonLabel={translate('btn.Close')}
                    onClose={() => this.toggleShowDetails()}
                >
                    <ExpenseExpenseDetailsDialog
                        resource={this.props.secondResource}
                        isLoading={this.props.secondResource.isLoading || this.props.resource.isLoading || this.props.download.isLoading}
                        translate={translate}
                        dispatch={this.props.dispatch}
                        type="expense"

                        showLoadReferenceLinks

                        disableComments={true}
                        canDeletePayment={false}
                        disableAddReference={true}
                        disableTransactionImport={true}

                        onDocumentDownload={(item) => {
                            const fileExt = item?.AttachPath.split('.').pop()

                            this.props.dispatch(download({
                                user: LocalStorage.get('user'),
                                resource: Resources.ExpenseDocuments,
                                query: Object.assign({
                                    id: item.ExpenseID,
                                    format: fileExt,
                                    name: 'document_' + currentDate() + '.' + fileExt
                                })
                            }))
                        }}

                        onFetchData={() => {
                            if (this.state.selectedItem) {
                                this.fetchExpenseDialogData()
                            }
                        }}
                    />
                </ModalDefault>

                <ModalSaveResource
                    title={translate('text.Edit_transaction')}
                    widthClass="max-w-md"
                    gridColsClass="grid-cols-3"
                    show={this.state.editModalOpen}
                    onClose={this.handleToggleEditModal}
                    fields={this.getEditFields(this.state.selectedItem)}
                    onSubmit={(params) => {
                        if (params) {
                            if (this.state.selectedItem.SendPaymentID) {
                                params.SendPaymentID = this.state.selectedItem.SendPaymentID
                            } else {
                                params.SendBatchPaymentID = this.state.selectedItem.SendBatchPaymentID
                            }
                            this.props.dispatch(updateResource({
                                user: LocalStorage.get('user'),
                                query: this.getQuery(),
                                params: params,
                                resource: this.getResource(),
                                piggyResource: this.getResource(),
                                errorMessage: true, successMessage: translate('text.transaction_updated')
                            }))
                            this.handleToggleEditModal()
                        }
                    }}
                    translate={this.props.translate}
                />

                <ModalConfirm
                    title={'Confirm'}
                    show={!!this.state.confirmModalOpen}
                    text={translate('text.confirm_delete')}
                    onClose={this.handleToggleConfirmModal}
                    buttonLabel={translate('btn.confirm')}
                    closeButtonLabel={'Cancel'}
                    translate={translate}
                    onConfirm={() => {
                        this.props.dispatch(deleteResource({
                            user: LocalStorage.get('user'),
                            query: Object.assign({
                                SendPaymentID: this.state.selectedItem?.SendPaymentID,
                                SendBatchPaymentID: this.state.selectedItem?.SendBatchPaymentID
                            }, this.getQuery()),
                            resource: Resources.ExpensePayment,
                            piggyResource: this.getResource(),
                            errorMessage: true,
                            successMessage: 'Payment deleted.'
                        }))
                        this.handleToggleConfirmModal(false)
                    }}
                />

                <ModalConfirm
                    title={'Confirm'}
                    show={!!this.state.confirmTransactionModalOpen}
                    text={translate('text.confirm_detach')}
                    onClose={this.handleToggleConfirmTransactionModal}
                    buttonLabel={translate('btn.confirm')}
                    closeButtonLabel={'Cancel'}
                    translate={translate}
                    onConfirm={() => {
                        this.props.dispatch(updateDialogResource({
                            user: LocalStorage.get('user'),
                            params: Object.assign({
                                SendPaymentID: this.state.selectedTransactionItem?.SendPaymentID,
                            }),
                            resource: Resources.ExpenseTransactionsDetach,
                            errorMessage: true,
                            successMessage: 'Transaction detached.',
                            piggyResource: Resources.ExpenseTransactionsDetails,
                            query: {
                                SendBatchPaymentID: this.state?.selectedTransactionsItem?.SendBatchPaymentID,
                                SendPaymentID: this.state?.selectedTransactionsItem?.SendPaymentID
                            }
                        }))
                        this.handleToggleConfirmTransactionModal()
                    }}
                />

                <ModalDefault
                    show={!!this.state.remitModalOpen}
                    widthClass={'max-w-7xl'}
                    limitHeight={true}
                    title={translate('preview')}

                    closeButtonLabel={translate('Close')}
                    onClose={() => this.handleToggleRemitModal()}
                    buttonLabel={translate('Download')}
                    onButtonClick={() => {
                        this.props.dispatch(download({
                            user: LocalStorage.get('user'),
                            resource: Resources.ExpenseTransactionsDetails,
                            query: Object.assign({}, {
                                pdf: 1,
                                name: 'transaction_' + currentDate() + '.pdf',
                                SendBatchPaymentID: this.state?.selectedTransactionsItem?.SendBatchPaymentID,
                                SendPaymentID: this.state?.selectedTransactionsItem?.SendPaymentID
                            }, () => this.getQuery),
                            errorMessage: true,
                            successMessage: 'Successfully downloaded remittance!'
                        }))
                    }}
                >
                    <FileViewer
                        fileType={'pdf'}
                        filePath={Env.getApiUrl('api/' + Resources.ExpenseTransactionsDetails, Object.assign({
                            pdf: 1,
                            SendBatchPaymentID: this.state?.selectedTransactionsItem?.SendBatchPaymentID,
                            SendPaymentID: this.state?.selectedTransactionsItem?.SendPaymentID
                        }, {
                            token: getJWT().access_token
                        }))}
                        onError={(e) => {
                            console.log(e)
                        }}
                    />
                </ModalDefault>
            </React.Fragment>
        )
    }
}

export default connect(state => state)(TransactionsTab)
